export default __webpack_public_path__ + "images/3V.1d1d9a0.png";